import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

// Array of font classes to cycle through
const chaoticFonts = [
  'font-heading', // Satoshi
  'font-serif',   // Playfair Display
  'font-mono',    // Space Mono
  'font-glitch',  // Rubik Glitch
];

const Hero = () => {
  const [fontClass, setFontClass] = useState('font-heading');

  useEffect(() => {
    // Start the chaotic interval immediately on component mount
    const chaosInterval = setInterval(() => {
      const randomIndex = Math.floor(Math.random() * chaoticFonts.length);
      setFontClass(chaoticFonts[randomIndex]);
    }, 100); // Changes font every 100ms

    // Set a timer to stop the chaos after 2.5 seconds (2500ms)
    const stopTimer = setTimeout(() => {
      clearInterval(chaosInterval); // Stop the font changing
      setFontClass('font-heading'); // Set the final, stable font (Satoshi)
    }, 2500);

    // Cleanup function to clear timers if the component unmounts
    return () => {
      clearInterval(chaosInterval);
      clearTimeout(stopTimer);
    };
  }, []); // The empty array [] ensures this effect runs only once

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.4, delayChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { 
      opacity: 1, 
      scale: 1, 
      transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } 
    },
  };

  return (
      // The change is on this line: removed py-20
      <section
      id="home"
      className="min-h-screen flex flex-col items-center justify-center bg-background text-center overflow-hidden px-4"
      >
      <motion.div
        className="flex flex-col items-center w-full"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {/* Orb with Description on top */}
        <motion.div
          className="relative flex items-center justify-center w-72 h-72 md:w-96 md:h-96 mb-12"
          variants={itemVariants}
        >
          <motion.div
            className="absolute inset-0 bg-accent rounded-full opacity-40 blur-3xl"
            animate={{
              scale: [1, 1.05, 1],
              transition: {
                duration: 8,
                repeat: Infinity,
                ease: "easeInOut",
              }
            }}
          />
          <p className="relative z-10 font-sans text-lg md:text-xl text-text-primary max-w-xs">
            A full stack developer crafting elegant solutions to complex problems.
          </p>
        </motion.div>

        {/* Name with Chaotic Font Animation */}
        <motion.div 
          className="w-full"
          variants={itemVariants}
        >
          <h1 className={`text-6xl sm:text-7xl md:text-8xl lg:text-9xl font-black text-text-primary whitespace-nowrap transition-all duration-100 ${fontClass}`}>
            Dheeraj Reddy
          </h1>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;